import { requestID ,baseURL,config, baseUrl} from "../../common/utils"
import axios from "axios"
export const getAllMembers = async () => {
//console.log('jello');
    const payload = {
        requestID: requestID(),
    }

    try {
        const res = await axios.post(`${baseURL}users/getAllUser2_ByBranch`, payload, config)

        console.log(res)
        return res.data
    } catch (error) {

        return error
    }
}





export const getProductSpecialList = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/getProductSpecial",
            data,
            config
        );
        console.log("getProductSpecial", response)
        return response.data

    } catch (error: any) {
        return error
    }

}



export const getStaffList_saleapp = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "businesss/getAllStaffs_saleapp",
            data,
            config
        );
        console.log("customers", response)
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getStaffList_crm_active = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "businesss/getAllStaffs_business_crm_active",
            data,
            config
        );
        console.log("customers", response)
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getStaffList_crm = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "businesss/getAllStaffs_business_crm",
            data,
            config
        );
        console.log("customers", response)
        return response.data

    } catch (error: any) {
        return error
    }

}


export const getStaffList = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "businesss/getAllStaffs2_hr_consulting",
            data,
            config
        );
        console.log("customers", response)
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getStaffListByBranchId = async (id) => {
    const data = {
        requestID: requestID(),
        branch_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + "businesss/getAllStaffs2",
            data,
            config
        );
        console.log("customers", response)
        return response.data

    } catch (error: any) {
        return error
    }

}


export const createCustomer = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/addCustomer",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const searchCustomers = async (payload) => {
    const data = {
        requestID: requestID(),
        data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/searchCustomers",
            data,
            config
        );
        console.log('search', response )
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomerGrades = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "warehouses/getAll_customer_product_grade",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const getCustomerTransactions = async (id) => {
    const data = {
        requestID: requestID(),
        customer_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + " orderhistorys/getCustomerOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const createCustomerPayment = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/recordCustomerOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const orderReport = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
        // data: payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/orderReport",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const approvedOrders = async (payload) => {
    const data = {
        requestID: requestID(), ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "orderhistorys/approvedOrders",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}


export const createStaff_crm = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "staffs/addStaffCRM",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}
export const createStaff = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "staffs/addStaffHr",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const suspendStaff = async (payload) => {
    const data = {
        requestID: requestID(),...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "staffs/suspendStaff",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}

export const onLogOut = async () => {
    const data = {
        requestID: requestID()
    };
    try {
        const response = await axios.post(
            baseUrl() + "users/logout",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }

}